var _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotionBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BOUTON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 281,
    height: 62,
    viewBox: "0 0 281 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Boue",
    "data-name": "Rectangle Boue",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 62,
    rx: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 279,
    height: 60,
    rx: 30,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_Boue",
    "data-name": "Path Boue",
    d: "M-17.256-16.344l6.48,13.392a3.131,3.131,0,0,1,.408,1.224q0,.864-1.392,1.56A3.148,3.148,0,0,1-13.044.24a1.282,1.282,0,0,1-.768-.216,1.434,1.434,0,0,1-.432-.456q-.132-.24-.372-.72l-1.248-2.592h-6.648L-23.76-1.152q-.24.48-.372.7a1.709,1.709,0,0,1-.432.444,1.234,1.234,0,0,1-.768.228,3.148,3.148,0,0,1-1.284-.408q-1.392-.672-1.392-1.536A3.131,3.131,0,0,1-27.6-2.952l6.48-13.416a2.1,2.1,0,0,1,.8-.888,2.124,2.124,0,0,1,1.14-.336A2.032,2.032,0,0,1-17.256-16.344Zm-1.944,5.76L-20.784-7.3h3.192Zm10.152-4.9a6.972,6.972,0,0,1,.036-.828,1.923,1.923,0,0,1,.228-.636q.336-.648,1.872-.648,1.68,0,1.992.888a4.773,4.773,0,0,1,.12,1.248V-2.112a6.928,6.928,0,0,1-.036.84,1.935,1.935,0,0,1-.228.624Q-5.4,0-6.936,0-8.616,0-8.9-.912a3.774,3.774,0,0,1-.144-1.224Zm8.3-2.136,4.44.024a8.616,8.616,0,0,1,6.12,2.508,8.174,8.174,0,0,1,2.64,6.168A8.62,8.62,0,0,1,9.876-2.64,8.456,8.456,0,0,1,3.624-.024H-.768q-1.464,0-1.824-.6A3.189,3.189,0,0,1-2.88-2.16V-15.5a6.928,6.928,0,0,1,.036-.84,1.935,1.935,0,0,1,.228-.624Q-2.28-17.616-.744-17.616ZM3.7-4.272a4.489,4.489,0,0,0,3.12-1.284A4.206,4.206,0,0,0,8.208-8.784a4.335,4.335,0,0,0-1.356-3.252,4.433,4.433,0,0,0-3.18-1.308h-2.3v9.072Zm14.568.024h7.392a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.888,1.968A4.013,4.013,0,0,1,25.632,0h-9.5q-1.68,0-1.968-.912a3.774,3.774,0,0,1-.144-1.224V-15.48a2.325,2.325,0,0,1,.456-1.668,2.508,2.508,0,0,1,1.728-.444h9.456a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.888,1.968a4.013,4.013,0,0,1-1.248.144H18.264v2.424h4.752a6.972,6.972,0,0,1,.828.036,1.923,1.923,0,0,1,.636.228q.648.336.648,1.872,0,1.68-.912,1.968a4.013,4.013,0,0,1-1.248.144h-4.7Z",
    transform: "translate(141 40)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "buoy",
    transform: "translate(21.081 -1.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14800",
    "data-name": "Path 14800",
    d: "M25.754,8A21.754,21.754,0,1,0,47.508,29.754,21.754,21.754,0,0,0,25.754,8Zm0,33.468A11.714,11.714,0,1,1,37.468,29.754,11.714,11.714,0,0,1,25.754,41.468Z",
    transform: "translate(0 3.243)",
    fill: "#e1503c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14801",
    "data-name": "Path 14801",
    d: "M5.673,31.427A21.751,21.751,0,0,1,41.948,15.233,21.752,21.752,0,1,0,11.233,45.948,21.671,21.671,0,0,1,5.673,31.427Z",
    transform: "translate(0 3.243)",
    fill: "#eb6e5a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384",
    transform: "translate(6.916 14.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14802",
    "data-name": "Path 14802",
    d: "M16.187,40.995l-8.7,5.023a21.851,21.851,0,0,0,7.962,7.962l5.023-8.7a11.754,11.754,0,0,1-4.284-4.284Z",
    transform: "translate(-7.486 -16.305)",
    fill: "#ddf2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14803",
    "data-name": "Path 14803",
    d: "M36.995,45.279l5.023,8.7a21.85,21.85,0,0,0,7.962-7.962l-8.7-5.023A11.755,11.755,0,0,1,36.995,45.279Z",
    transform: "translate(-12.305 -16.305)",
    fill: "#ddf2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14804",
    "data-name": "Path 14804",
    d: "M41.279,24.471l8.7-5.023a21.85,21.85,0,0,0-7.962-7.962l-5.023,8.7A11.754,11.754,0,0,1,41.279,24.471Z",
    transform: "translate(-12.305 -11.486)",
    fill: "#ddf2f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385",
    transform: "translate(6.916 14.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14805",
    "data-name": "Path 14805",
    d: "M11.744,52.178a21.792,21.792,0,0,1-3.628-5.614l-.63.363a21.836,21.836,0,0,0,4.258,5.251Z",
    transform: "translate(-7.486 -17.214)",
    fill: "#f4ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14806",
    "data-name": "Path 14806",
    d: "M42.928,11.486l-.364.63a21.79,21.79,0,0,1,5.615,3.629,21.833,21.833,0,0,0-5.252-4.259Z",
    transform: "translate(-13.214 -11.486)",
    fill: "#f4ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14807",
    "data-name": "Path 14807",
    d: "M20.471,20.187l-5.023-8.7a21.85,21.85,0,0,0-7.962,7.962l8.7,5.023a11.753,11.753,0,0,1,4.284-4.284Z",
    transform: "translate(-7.486 -11.486)",
    fill: "#f4ffff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14808",
    "data-name": "Path 14808",
    d: "M9.858,20.981l6.716,3.877a11.755,11.755,0,0,1,4.284-4.284l-3.877-6.716a21.862,21.862,0,0,0-7.123,7.123Z",
    transform: "translate(-0.957 2.286)",
    fill: "#ddf2f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotionBtn);
export default __webpack_public_path__ + "static/media/notion-btn.278c326d.svg";
export { ForwardRef as ReactComponent };